// removed by extract-text-webpack-plugin
module.exports = {"component":"_23EUOJ4505cm3HErVuNkUe","img":"_1NRCkCm9oBbnj2vClgjplP","big":"ftBzUNIvAOb7FpxRkZz_X","sat":"_33_2ZdJg2MFhAHYxh2WF3_","txt":"_3VLANG4pzE7bwp8aT2a1yg","span":"_3aypSUuBcM4V-A0BVEBlt5","mr0":"_3ztMHAFBDqAht7D0nj3Fu4"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ArtSalonComponent/ArtSalonComponent.scss
 ** module id = 946
 ** module chunks = 0
 **/